export default "__VITE_ASSET__MaXI0wO$__"